import { Fragment } from "react/jsx-runtime";
import { CCAssessmentType, EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import CCAbccAssessmentSummary from "./CCAbccAssessmentSummary";
import CCExamAssessmentSummary from "./CCExaminationAssessmentSummary";
import CCOtherAssessmentSummary from "./CCOtherAssessmentSummary";
import { AbccAssessment, AbccAssessmentModule, AbccAssessmentStatus } from "../Models/CCAssessment";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";

interface IProps{
    ccEnrollmentCertificate: EnrollmentCertificate;
    abccAssessments: AbccAssessment[];
    acceptAbccModuleAttestation: (abccAssessmentModule: AbccAssessmentModule) => void;
}


export default function CCEnrollmentCertificateAssessment(props: IProps){

    const displayCCEnrolmmentCertificateAssessment = ()=> { 
        switch (props.ccEnrollmentCertificate.ccAssessmentType){
            case CCAssessmentType.Article :
                return displayAbccAssessment();
            case CCAssessmentType.Exam :
                return <CCExamAssessmentSummary />
            case CCAssessmentType.Other :
                return <CCOtherAssessmentSummary />
        }
    }

    const displayAbccAssessment = () => {
        if (!props.abccAssessments || !props.abccAssessments.length) {
            return;
        }

        const filteredResults = props.abccAssessments
            .filter(_ => {
                const endDateWithOffset = getDateWithOffset(_.endDate);
                return (_.certificateId == props.ccEnrollmentCertificate.certificateId
                && endDateWithOffset && endDateWithOffset > new Date())
                && (_.abccAssessmentStatusId == AbccAssessmentStatus.Authorized 
                    || _.abccAssessmentStatusId == AbccAssessmentStatus.AuthorizationPending)
            })
            .sort((a: AbccAssessment, b: AbccAssessment) => {
                const dateA = getDateWithOffset(a.startDate);
                const dateB = getDateWithOffset(b.startDate);

                if (dateA === null && dateB === null) return 0;
                if (dateA === null) return 1; // null dates are considered "greater" to sort them later
                if (dateB === null) return -1; // null dates are considered "greater" to sort them later

                return dateA.getTime() - dateB.getTime();
            });

        // Get the first item from the sorted results
        const activeAssessment = filteredResults[0] || null; // Returns null if the array is empty
        
        if (activeAssessment == null) {
            let ccEnrollmentCertificateStartDate = getDateWithOffset(props.ccEnrollmentCertificate.enrollmentStartDate);
            if (ccEnrollmentCertificateStartDate && ccEnrollmentCertificateStartDate > new Date()) 
                {
                    return <div>{`Assessment requrirements will begin in ${ccEnrollmentCertificateStartDate.getFullYear()} `}.</div> 
            }
            
            return <div>There is no currently active ABCC Assessment for this Certifiate at this time.</div> 
        }

        return <CCAbccAssessmentSummary abccAssessment={activeAssessment} acceptAbccModuleAttestation={props.acceptAbccModuleAttestation} />
    }



    return (<Fragment>
        {displayCCEnrolmmentCertificateAssessment()}
    </Fragment>);
}